import React from "react";
import "animate.css";
import "./Home.css";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

function Home() {
  useEffect(() => {
    AOS.init({
      duration: 1200, // Durasi animasi 1000ms
      easing: "ease-in-out",
      once: false, // animasi bisa muncul saat scroll naik & turun
      mirror: true, // animasi juga muncul saat scroll ke atas
    });
    AOS.refresh();
  }, []);

  const servicesData = [
    { title: "产品开发", image: "/images/service1.png" },
    { title: "原型制作与产品样品", image: "/images/service2.png" },
    { title: "贴牌生产", image: "/images/service3.png" },
    { title: "定制包装设计", image: "/images/service4.png" },
    { title: "质量控制与合规", image: "/images/service5.png" },
    { title: "物流与出口支持", image: "/images/service6.png" },
  ];

  return (
    <div className="page-container">
      {/* HERO SECTION */}
      <div
        className="hero-wrapper animate__animated animate__fadeIn"
        style={{ backgroundImage: `url("/images/bed.png")` }}
      >
        <div className="hero-content-cn text-white text-center">
          <div className="container">
            <h1 className="display-3 fw-bold mb-3 animate__animated animate__fadeInUp animate__delay-1s welcome">
              欢迎 —
            </h1>
            <p className="lead fs-3 animate__animated animate__fadeInUp animate__delay-2s comfort">
              带来舒适, 创造幸福
            </p>
          </div>
        </div>
      </div>

      {/* OUR SERVICES */}
      <div
        id="services"
        className="container py-5 section-fade mt-5"
        data-aos="fade-up"
      >
        <h2 className="section-title-product text-center">我们的OEM服务</h2>
        <div className="row g-4">
          {servicesData.map((service, idx) => (
            <div
              className="col-md-4"
              key={idx}
              data-aos="fade-up"
              data-aos-delay={idx * 100}
            >
              <div
                className="service-card position-relative overflow-hidden rounded"
                style={{ backgroundImage: `url(${service.image})` }}
              >
                <div className="service-overlay d-flex align-items-center justify-content-center text-center">
                  <h5 className="text-white fw-bold px-2 mb-0">
                    {service.title}
                  </h5>
                </div>
              </div>
            </div>
          ))}
        </div>
        <br />
        <h2 className="section-title-product text-center fs-3 tagline-service">
          为您的品牌提供动力
        </h2>
      </div>

      {/* WHO WE ARE */}
      <div
        className="container-fluid text-white py-5 section-fade"
        data-aos="fade-in"
        style={{
          backgroundImage: 'url("/images/BG - HOME PAGE.png")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 0,
          }}
        />
        <div
          className="container d-flex flex-column flex-md-row align-items-center justify-content-between"
          style={{ position: "relative", zIndex: 1 }}
        >
          <div className="mb-4 mb-md-0" style={{ maxWidth: "600px" }}>
            <h2 className="who-title">我们是谁</h2>
            <p className="who-text">
              我们是一家总部位于印度尼西亚的OEM和家具制造商,
              <br /> 专注于高质量床垫、枕头和各种定制产品。
            </p>
            <p className="who-text">
              我们始终致力于质量与准时交付，
              <br /> 帮助客户打造适合其市场的品牌家具解决方案
              <br />
            </p>
            <Link
              to="/about#company-profile"
              className="btn btn-light rounded-pill px-4 mt-2"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      {/* PROJECT HIGHLIGHTS */}
      <div
        className="project-highlights-section text-center section-fade"
        data-aos="zoom-in"
      >
        <h2 className="highlight-title">项目亮点</h2>
        <div className="highlight-divider"></div>
        <p className="highlight-description">
          我们已成功完成多个为私营企业和政府机构定制的生产项目
        </p>
        <div className="highlight-divider"></div>

        {/* Lingkaran dengan ikon handshake + journal + tombol */}
        <div className="highlight-circle mx-auto mt-4 d-flex flex-column align-items-center justify-content-center">
          {/* Logo handshake di atas */}
          <img
            src="/images/handshake.png"
            alt="Handshake"
            className="highlight-handshake mb-2"
          />

          {/* Ikon journal yang sudah ada */}
          <i
            className="bi bi-journal-check text-white mb-2"
            style={{ fontSize: "2.5rem" }}
          ></i>

          {/* Tombol */}
          <button className="btn btn-dark rounded-pill px-4 py-1">
            了解更多
          </button>
        </div>
      </div>

      {/* FOOTER SECTION */}
      <div
        className="footer-section text-white section-fade"
        style={{ backgroundColor: "#754c24" }}
        data-aos="fade-up"
      >
        <div className="container-fluid px-0">
          <div className="row g-0">
            <div
              className="col-md-3 d-flex align-items-center justify-content-center"
              style={{ backgroundColor: "#5c3e1c", position: "relative" }}
            >
              <img
                src="/images/dotwall.jpg"
                alt="FORMEB Logo"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  zIndex: 0,
                }}
              />
              <div
                className="text-center py-4 px-3"
                style={{ zIndex: 1, position: "relative" }}
              >
                <img
                  src="/images/logo.png"
                  alt="FORMEB Logo"
                  style={{ maxWidth: "350px" }}
                />
                <p className="footer-tagline mt-2 fst-italic text-white">
                  Foremost Living Style
                </p>
              </div>
            </div>

            <div className="col-md-9 px-4 py-5">
              <div className="row text-start">
                <div className="col-md-4 mb-4 mb-md-0 border-end border-light px-4">
                  <h5 className="footer-title text-white">产品</h5>
                  <ul className="list-unstyled footer-links">
                    <li>床垫</li>
                    <li>枕头</li>
                    <li>泡沫</li>
                  </ul>
                </div>
                <div className="col-md-4 mb-4 mb-md-0 border-end border-light px-4">
                  <h5 className="footer-title text-white">关于我们</h5>
                  <ul className="list-unstyled footer-links">
                    <li>
                      <Link
                        to="/about-cn#company-profile"
                        className="text-white text-decoration-none"
                      >
                        公司简介
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products#services"
                        className="text-white text-decoration-none"
                      >
                        服务
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products#services"
                        className="text-white text-decoration-none"
                      >
                        项目亮点
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products#services"
                        className="text-white text-decoration-none"
                      >
                        职业
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4 ps-4">
                  <h5 className="footer-title text-white">联系方式</h5>
                  <ul className="list-unstyled footer-links">
                    <li>
                      <Link
                        to="/contact-cn"
                        className="text-white text-decoration-none"
                      >
                        联系方式
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/contact-cn"
                        className="text-white text-decoration-none"
                      >
                        我们的位置
                      </Link>
                    </li>
                    <li className="mt-2">
                      <a
                        href="mailto:xxxxxx@gmail.com"
                        className="text-white me-3"
                      >
                        <i className="bi bi-envelope"></i>
                      </a>
                      <a
                        href="https://www.linkedin.com/company/pt-foremost-mebel-indonesia/posts/?feedView=all"
                        className="text-white"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="bi bi-linkedin"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <hr className="text-light my-4" />
              <div className="row">
                <div className="col-md-6">
                  <p className="footer-email fw-bold text-white">
                     contact@formeb.id
                  </p>
                  <address className="footer-address text-white mt-2">
                    PT. FOREMOST MEBEL INDONESIA
                    <br />
                    Jl. Gemilang, RT.002/RW.003, Tlajung Udik,
                    <br />
                    Kec. Gn. Putri, Kabupaten Bogor, Jawa Barat 16963
                  </address>
                </div>
              </div>
              <div className="d-flex justify-content-end mt-4 small text-light">
                ©2025 Foremost Mebel Indonesia. All Rights Reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
